<template>
    <x-select-tree  :config="config" :datas="treeDatas"
        :select-type="selectType"
        @selected="selectedChangeHandler"
    ></x-select-tree>
</template>

<script setup>
import { getCurrentInstance, ref, watch } from 'vue';
import SelectType from '../components/data/SelectType';
import { useTokenStore } from '../store/TokenStore';
import ModuleCenter from '../datamodule/ModuleCenter';
import XSelectTree from '../components/base/XSelectTree.vue';
import { dayjs } from 'element-plus';
import TimeService from '../remoteservice/TimeService';

const inst = getCurrentInstance();
const token = useTokenStore();

const props = defineProps({
    config: { default: null },
    selectType: { default: SelectType.MULTIPLE_SELECT },
    selected: { default: null },

    data: { default: null },
})
defineEmits({
    'update:selected': null,
})

const treeDatas = ref(null);

const dataView = ref(null);

const dataOptions = ref(null);
const selectedValue = ref(null);
const updateOptions = (selected)=> {
    const keyField = props.config?.keyField || 'id';
    const nameField = props.config?.nameField || 'name';
    const options = [];
    let value = [];

    if (selected) {
        if (selected instanceof Array) {
            value = [];
            for (const data of selected) {
                const v = data[keyField];
                const n = data[nameField];
                value.push(v);
                options.push({value:v, label:n});
            }
        } else {
            const v = selected[keyField];
            const n = selected[nameField];
            value = v;
            options.push({value:v, label:n})
        }
    }
    dataOptions.value = options;
    selectedValue.value = value;
}

const selectedDatas = ref(null);
watch(()=> props.selected, (value)=> {
    updateOptions(value);
    selectedDatas.value = value;
}, {immediate:true})

const getTagConfig = (config, dataOptions)=> {
    return Object.assign({}, config, {dataOptions:dataOptions || [], closable:true});
}

const getFilter = (filter)=> {
    if (!filter) return {query:{}, options:null};
    const query = {};
    const options = {};
    for (const [key, value] of Object.entries(filter)) {
        if (value instanceof Object && !(value instanceof Array)) {
            if (value.in) {
                query[key] = value.in.split(/\s*\.\s*/).reverse();
                options[key] = 'relate-in';
            } else if (value.not) {
                query[key] = value.not.split(/\s*\,\s*/).reverse();
                options[key] = 'notin';
            } else if (value.notin) {
                query[key] = value.notin.split(/\s*\.\s*/).reverse();
                options[key] = 'relate-notin';
            } else if (value.relate) {
                query[key] = value.relate;
                options[key] = 'multi-relate';
            }
        } else {
            query[key] = value;
        }
    }
    return {query:query, options:options};
}
const getQuery = (queryConfig, data)=> {
    if (!queryConfig) return {};
    const query = {};
    const options = {};
    queryConfig = queryConfig.replace(/([\w\,\.\:]+?)\?(?:\{(\w+)\}|([\w\'\"]+))/g, ($0, $1, $2, $3)=> {
        let keys = $1;
        let o = $2 || null;
        let ov = null;
        switch (o) {
            case null: ov = null; break;
            case 'loginUser': ov = token.userid; break;
            case 'loginUserName': ov = token.username; break;
            case 'now': ov = dayjs(TimeService.getServerTimeStamp()).format('YYYY-MM-DD HH:mm:ss'); break;
            default: ov = data[o];
        }
        const r = $3 != null ? $3.replace(/\'/g, '"') : null;
        let v = r != null ? JSON.parse(r) : ov;
        if (v == null) v = '';
        keys = keys.split(/[\,\.\:]/);
        let key = keys.shift();
        while(query[key]) key += '+';
        const value = [keys, ['' + v]];
        query[key] = value;
        options[key] = 'multi-relate';
        return '';
    })
    queryConfig = queryConfig.replace(/(\w+)(\=|\>|\<)(?:\{(\w+)\}|([\w\'\"]+))/g, ($0, $1, $c, $2, $3)=> {
        const c = $c;
        let key = $1;
        while(query[key]) key += '+';
        let o = $2 || null;
        let ov =  null;
        switch (o) {
            case null: ov = null; break;
            case 'loginUser': ov = token.userid; break;
            case 'loginUserName': ov = token.username; break;
            case 'now': ov = dayjs(TimeService.getServerTimeStamp()).format('YYYY-MM-DD HH:mm:ss'); break;
            default: ov = data[o];
        }
        const r = $3 != null ? $3.replace(/\'/g, '"') : null;
        let v = r != null ? JSON.parse(r) : ov;
        if (c == '=') {
            if (v != null) query[key] = v;
        } else if (c == '>') {
            if (v != null) {
                if (!query[key]) query[key] = [v, null];
                else query[key][0] = v;
            }
            options[key] = 'range';
        } else if (c == '<') {
            if (v != null) {
                if (!query[key]) query[key] = [null, v];
                else query[key][1] = v;
            }
            options[key] = 'range';
        }
        
        return '';
    })
    queryConfig = queryConfig.replace(/(\w+)\=([^\s\&]+)/g, ($0, $1, $2)=> {
        const key = $1
        let value = $2.split(/\s*\,\s*/);
        value = value.map((v)=>JSON.parse(v));
        if (value.length == 1) value = value[0];
        query[key] = value;
        return '';
    })
    return {query:query, options:options};
}
const queryParams = ref(null);

watch(()=> props.config, async (value)=> {
    console.log(props.config?.dataOptions)
    if (props.config?.dataOptions && props.config.dataOptions instanceof Array) {
        treeDatas.value = props.config.dataOptions;
        return;
    }
    const module = ModuleCenter.getModule(props.config?.module);
    const f = getFilter(props.config?.filter);
    const def = getQuery(props.config?.condition, props.data);
    queryParams.value = {query:Object.assign({}, f?.query, def?.query), options:Object.assign({}, f?.options, def?.options)};
    console.log(queryParams.value);
    // query here
    const pagination = { pageNumber:  1, pageSize: 20000,order:[{field:'sortBy', direction:'ASC'}]};
   
    const data = await module.queryDatas({},null,pagination);
    treeDatas.value = data;
}, {immediate:true})

const selectedChangeHandler = (selected)=> {
    updateOptions(selected);
    inst.emit('update:selected', selected);
}

</script>